<template>
  <b-card no-body class="mb-3">
    <b-card-title class="mt-2">
      <b-container fluid>
        <b-row align-h="between">
          <b-col cols="12">
            <h3>{{ contract.name }}</h3>
          </b-col>
        </b-row>
      </b-container>
    </b-card-title>
    <b-card-sub-title>
      <b-container fluid>
        <b-row align-h="between">
          <b-col md="8" sm="12">
            <span>{{ contract.date | toDateTime }}</span>
          </b-col>
        </b-row>
      </b-container>
    </b-card-sub-title>
    <b-card-body>
      <b-row>
        <b-col md="8" xs="12">
          <p>{{ contract.description }}</p>
        </b-col>
        <b-col md="4" xs="12">
          <b-button
            block
            :variant="
              contract.hasFile || contract.hasCommunicationFile ? 'primary' : ''
            "
            size="lg"
            :disabled="!contract.hasFile && !contract.hasCommunicationFile"
            @click="openPdf()"
          >
            {{
              contract.hasFile || contract.hasCommunicationFile
                ? 'Ver contrato'
                : 'Sin fichero'
            }}
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
    <b-card-footer v-if="contract.seen || contract.confirmationRequested">
      <b-row>
        <template v-if="contract.confirmationRequested">
          <b-col md="6" xs="12">
            <b-button
              v-if="
                !contract.confirmed || (contract.confirmed && contract.accepted)
              "
              class="mr-3"
              block
              size="lg"
              :disabled="contract.confirmed"
              :variant="
                contract.confirmed
                  ? contract.accepted
                    ? 'success'
                    : ''
                  : 'success'
              "
              @click="processAcceptContract()"
            >
              {{
                contract.confirmed
                  ? contract.accepted
                    ? 'Aceptado'
                    : ''
                  : 'Acepto'
              }}
            </b-button>
          </b-col>
          <b-col md="6" xs="12">
            <b-button
              v-if="
                !contract.confirmed ||
                (contract.confirmed && !contract.accepted)
              "
              size="lg"
              block
              :disabled="contract.confirmed"
              :variant="
                contract.confirmed
                  ? !contract.accepted
                    ? 'danger'
                    : ''
                  : 'danger'
              "
              @click="processRejectContract()"
            >
              {{
                contract.confirmed
                  ? !contract.accepted
                    ? 'No aceptado'
                    : ''
                  : 'No acepto'
              }}
            </b-button>
          </b-col>
          <b-col v-if="contract.confirmed" cols="12">
            <p class="card-footer-notes">
              {{ contract.accepted ? 'Aceptado' : 'Rechazado' }} el
              {{ contract.confirmationDate | toDateTime }}
            </p>
          </b-col>
        </template>
        <b-col v-if="contract.seen" cols="12">
          <p class="mt-2 mb-0 card-footer-notes">
            {{ contract.seen ? 'Visto' : 'No visto' }} el
            {{ contract.seenDate | toDateTime }}
          </p>
        </b-col>
      </b-row>
    </b-card-footer>
  </b-card>
</template>
<script>
import { mapActions } from 'vuex'
import { openFile } from '@/services/filesService.js'
import { errorOnFileLoad } from '@/services/messageService'

export default {
  name: 'ContractCard',
  props: {
    contract: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      pdfUrl: '',
    }
  },
  methods: {
    ...mapActions('notices', ['acceptNotice', 'rejectNotice', 'seenNotice']),
    async openPdf() {
      try {
        const fileProperties = {
          entity: 'contract',
          entityID: this.contract.noticeId,
          global: this.contract.hasCommunicationFile,
          name: this.contract.name,
        }
        await openFile(fileProperties)
        await this.seenNotice(this.contract.noticeId)
        window.location.reload()
      } catch (error) {
        errorOnFileLoad({ context: this, error })
      }
    },
    processAcceptContract() {
      this.acceptNotice(this.contract.noticeId).then(() => {
        window.location.reload() // @TODO Figure out the computed property not reloading on state update
      })
    },
    processRejectContract() {
      this.rejectNotice(this.contract.noticeId).then(() => {
        window.location.reload() // @TODO Figure out the computed property not reloading on state update
      })
    },
  },
}
</script>
<style>
.card-footer-notes {
  margin-bottom: 0;
  margin-top: 0.25em;
}
</style>
